// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__XGnik","btn":"Footer_btn__QRtoE"};